import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

// 1. Create the Context
const FeatureContext = createContext({});

// 2. Create the Provider
export const FeatureProvider = ({ children }) => {
  // Pull flags from the window object we set in Rails
  // We use useMemo so the object reference doesn't change unless the window object does
  const flags = useMemo(() => {
    return window.AppConfig?.features || {};
  }, []);

  return (
    <FeatureContext.Provider value={flags}>
      {children}
    </FeatureContext.Provider>
  );
};

FeatureProvider.propTypes = {
  children: PropTypes.node.isRequired
};

// 3. Create the Hook
export const useFeature = (flagName) => {
  const flags = useContext(FeatureContext);

  // Return the boolean value, defaulting to false if the flag doesn't exist
  return !!flags[flagName];
};
